import { render, staticRenderFns } from "./PopupPoints.vue?vue&type=template&id=90031d1a&"
import script from "./PopupPoints.vue?vue&type=script&lang=js&"
export * from "./PopupPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports